var map = {
	"./1.png": "sbdv",
	"./2.png": "fQrd",
	"./bronze.png": "r2Nz",
	"./consolation.png": "cRf0",
	"./gold.png": "Qxgx",
	"./silver.png": "TacR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kKRZ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/medals ^\.\/.*\.png$
// module id = kKRZ
// module chunks = 1